<template>
    <div class="my-cd">
        <div class="cd-list">
            <van-row class="user-links1">
                <van-col @click="to(item)" v-for="item in items">
                    <van-icon :class="'iconfont '+ item.tmIcon" size="25" style="color: #2b94ff;display: block"/>
                    {{item.menuName}}
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        components: {
        },
        data() {
            return {
                deptId: '',
                phone: '',
                bps: [],
                ysItem: {},
                items: [],
            };
        },
        props: {
            item: Object
        },
        async created() {
            this.ysItem = this.item
            this.deptId = getDeptId()
            this.getStyleMenus()
        },
        methods: {
            async getStyleMenus() {
                let data = {
                    deptId: this.deptId,
                    styleId: this.ysItem.id,
                    isShow: "0",
                }
                let res = await this.$get("/spm/getSpmStyleMenus", data)
                this.items = res.list
            },
            to(item){
                if (item.route=='wkf'){
                    this.$notify({
                        message: '此功能正在开发',
                        duration: 1000,
                        background: 'red'
                    });
                    return;
                }
                this.$router.push(item.route+'/' + this.deptId)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .my-cd {
        background-color: #FFFFFF;
        margin: 0 8px 8px 8px;
        border-radius: 5px;
    }

    .cd-list {
        width: 95%;
        margin: auto;
    }
    .user-links1 {
        padding: 10px 0;
        font-size: 12px;
        text-align: center;
        background-color: #fff;
    }

    .user-links1 .van-icon {
        display: block;
        font-size: 0.64rem;
        height: 32px;
    }

    .user-links1 .van-row {
        padding: 10px 0;
    }

    .user-links1 .van-col {
        float: left;
        box-sizing: border-box;
        min-height: 0.02667rem;
        width: 25%;
        margin: 12px 0;
    }

    ::v-deep .van-cell {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 8px 3px;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.61rem;
        background-color: #fff;
    }


</style>
